import { Environment } from './environment.types';

export const environment: Environment = {
  production: false,
  apiUrls: {
    auctionService: 'https://auction-service-service-419414982676.us-east1.run.app/v1',
    lotsService: 'https://lot-service-service-419414982676.us-east1.run.app',
    authService: 'https://auction-login-service-419414982676.us-east1.run.app/v1',
    auditService: 'https://audit-service-service-522132320473.us-east1.run.app/v1',
    uploadFilesService: 'https://upload-files-service-419414982676.us-east1.run.app/v1',
    notificationsService: 'https://notificaciones-service-service-419414982676.us-east1.run.app/v1',
    officialInformationService: 'https://auction-service-service-419414982676.us-east1.run.app/v1',
  },
  firebase: {
    apiKey: 'AIzaSyB8Kqn56wLKeW5hyNq5__b7g5hfKDwQxR4',
    appId: '1:419414982676:web:17320a4fedf01dce50a701',
    projectId: 'gcs-sem-auction-qa',
    messagingSenderId: '419414982676',
    authDomain: 'gcs-sem-auction-qa.firebaseapp.com',
    storageBucket: 'gcs-sem-auction-qa.firebasestorage.app',
    measurementId: '',
    vapidKey: '',
  },
};

